<template id="product_list">
  <b-container fluid>
      <b-row>
        <b-col>
          <h1 class="h1">Productes</h1>
        </b-col>
        <b-col class="col text-right">
          <b-button class="p-2 m-2" variant="outline-success">
            <router-link
              :to="{
                name:'ProducteAdd'
              }"
              class="icon"
              >
              <b-icon icon="plus" ></b-icon>
              Nou Producte
            </router-link>
          </b-button>
        </b-col>
      </b-row>
       <br>
      <b-row>
         <b-col lg="6" class="my-1">
            <b-form-group
              label="Sort"
              label-cols-sm="3"
              label-align-sm="right"
              label-size="sm"
              label-for="sortBySelect"
              class="mb-0"
            >
              <b-input-group size="sm">
                <b-form-select v-model="sortBy" id="sortBySelect" :options="sortOptions" class="w-75">
                  <template v-slot:first>
                    <option value="">-- none --</option>
                  </template>
                </b-form-select>
                <b-form-select v-model="sortDesc" size="sm" :disabled="!sortBy" class="w-25">
                  <option :value="false">Asc</option>
                  <option :value="true">Desc</option>
                </b-form-select>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col lg="6"></b-col>
          <!-- //Canvi de Fila -->
          <b-col lg="6">
            <b-form-group
                label="Filtro: "
                label-cols-sm="2"
                label-align-sm="right"
                label-size="sm"
                label-for="filterInput"
                class="mb-0"
                >
                <b-input-group  size="sm">
                    <b-form-input
                        v-model="filter"
                        type="search"
                        id="filterInput"
                        placeholder="busqueda por nombre.."
                    ></b-form-input>
                    <b-input-group-append>
                    <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                    </b-input-group-append>
                </b-input-group>
            </b-form-group>
          </b-col>
           <b-col lg="6" class="my-1">
              <b-form-group
                label="Filter On"
                label-cols-sm="3"
                label-align-sm="right"
                label-size="sm"
                description="Leave all unchecked to filter on all data"
                class="mb-0">
                <b-form-checkbox-group v-model="filterOn" class="mt-1">
                  <b-form-checkbox value="name">Nombre</b-form-checkbox>
                  <b-form-checkbox value="descripcion">Descripció</b-form-checkbox>
                  <b-form-checkbox value="isActive">Esta Activo</b-form-checkbox>
                </b-form-checkbox-group>
              </b-form-group>
            </b-col>
        </b-row>
        <br>
        <b-table
            :tbody-tr-class="rowClass"
            primary-key = productes.identifier
            :items="productes"
            :fields="fieldsProductes"
            hover
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            :filterIncludedFields="filterOn"
            @filtered="onFiltered"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
        >
            <template v-slot:cell(nombre)="data">
                <router-link
                  :to="{
                    name:'ProducteDetails',
                    params:{Producte: data.item}
                  }">
                  {{ data.item.nombre}}
                </router-link>
            </template>
            <template v-slot:cell(acciones)="data">
                <router-link
                  :to="{
                    name:'ProducteEdit',
                    params:{producte: data.item}
                  }"
                  class="icon"
                  >
                  <b-icon icon="pen" variant="info"></b-icon>
                </router-link>
                <router-link
                  :to="{
                    name:'ProducteDelete',
                    params:{producte: data.item}
                  }"
                  class="icon"
                  >
                  <b-icon icon="trash" variant="danger"></b-icon>
                </router-link>
            </template>
        </b-table>
        <b-row>
          <b-col sm="5" md="6" class="my-1">
            <b-form-group
              label="Per pàgina"
              label-cols-sm="6"
              label-cols-md="4"
              label-cols-lg="3"
              label-align-sm="right"
              label-size="sm"
              label-for="perPageSelect"
              class="mb-0"
            >
              <b-form-select
                v-model="perPage"
                id="perPageSelect"
                size="sm"
                :options="pageOptions"
              ></b-form-select>
            </b-form-group>
          </b-col>
          <b-col sm="7" md="6" class="my-1">
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              align="fill"
              size="sm"
              class="my-0"
            ></b-pagination>
          </b-col>
        </b-row>
  </b-container>
<!-- <b-dropdown-item :to="{ name: 'CargaDMS', params: {isAdmin:isAdmin, isResp:isCustomerAdmin}}">Nuevo Fichero</b-dropdown-item> -->
</template>

<script>
import DataAccess from '@/Services/DataAccess.js'

export default {
  data () {
    return {
      loading: true,
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [1, 5, 10, 15, 20],
      filter: null,
      filterOn: [],
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      productes: [],
      fieldsProductes: [
        {
          key: 'nombre',
          label: 'Nombre',
          sortable: true,
          sortDirection: 'desc'
        },
        {
          key: 'descripcion',
          label: 'Descripció',
          sortable: false
        },
        {
          key: 'import',
          label: 'Importe',
          sortable: true
        },
        {
          key: 'isActive',
          label: 'Está Activo',
          formatter: (value, key, item) => {
            return value ? 'Sí' : 'No'
          },
          sortable: true,
          sortByFormatted: true,
          filterByFormatted: true
        },
        {
          key: 'acciones',
          label: 'Acciones'
        }
      ]
    }
  },
  computed: {
    sortOptions () {
      // Create an options list from our fields
      return this.fieldsProductes
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key }
        })
    }
  },
  created () {
    (async () => {
      await DataAccess.getData('/api/products')
        .then(response => {
          this.productes = response.data
          this.totalRows = this.productes.length
          this.loading = false
        })
        .catch(error => {
          console.log('ERROR: ', error)
        })
    })()
  },
  methods: {
    rowClass (item, type) {
      if (!item || type !== 'row') return
      // PENDENT
      if (item.inRequest) return 'table-success'
    },
    makeToast (toaster, variant, title, message, append = false) {
      this.$bvToast.toast(message, {
        toaster: toaster,
        title: title,
        variant: variant,
        solid: true,
        append: append
      })
    },
    onFiltered (filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    }
  }
}
</script>
